import React from 'react';
import PricePredictor from './components/PricePredictor';
import './App.css';

function App() {
  return (
    <div className="App">
      <PricePredictor />
    </div>
  );
}

export default App;
